export enum MaintenanceModeEnum {
  Global = 'global',
  Register = 'register',
  Login = 'login',
  None = 'none'
}
